import React from "react";
import { motion } from "framer-motion";

const ContactSection = () => {
  // const scrollToSection = (sectionId) => {
  //   const element = document.getElementById(sectionId);
  //   if (element) {
  //     element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // };

  return (
    <section
      id="contact"
      className="section-padding 
      bg-white dark:bg-gray-800 
      transition-colors duration-300"
    >
      <div className="container-custom w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-2 text-gray-900 dark:text-gray-100">
            <span className="text-teal-700 dark:text-accent">04.</span>
            Contact Me
          </h2>
          <div className="w-32 h-0.5 bg-teal-700 dark:bg-accent mb-8"></div>
        </motion.div>

        <p className="text-gray-700 dark:text-gray-400 text-sm md:text-lg leading-relaxed mb-8 text-center max-w-3xl mx-auto">
          If you would like to connect with me, feel free to reach out. I look
          forward to connecting with you.
        </p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-center"
        >
          <a
            href="mailto:harshalaglawe1@gmail.com?subject=Connecting Through Your Portfolio.&body=Hello Harshal,"
            className="
              px-8 py-3 text-sm md:text-base 
              border border-teal-700 dark:border-accent 
              text-teal-700 dark:text-accent 
              rounded 
              hover:bg-teal-700/10 dark:hover:bg-accent/10 
              transition-all duration-300 font-medium"
          >
            Say Hello!
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
